import { render, staticRenderFns } from "./InformationCheck.vue?vue&type=template&id=9d96165c&scoped=true"
import script from "./InformationCheck.vue?vue&type=script&lang=js"
export * from "./InformationCheck.vue?vue&type=script&lang=js"
import style0 from "./InformationCheck.vue?vue&type=style&index=0&id=9d96165c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d96165c",
  null
  
)

export default component.exports